import React, { FC } from 'react';
import type { JSX } from 'react';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import Link from '../../Controls/Link';

import css from './style.module.scss';
import classNames from 'classnames';
import setQaAttribute from '../../../helpers/setQaAttribute';
import { SUPPORT_CARD_ICON, SUPPORT_CARD_NAME } from '../../../constants/qaAttributes';

interface IconWithName {
  name: string;
  url?: never;
}

interface IconWithUrl {
  url: string;
  name?: never;
}

interface IProps {
  link: string;
  icon?: IconWithName | IconWithUrl;
  title?: string;
  description?: string;
  goToAction?: {
    title: string;
    icon: string;
  };
  size?: 'small';
  children?: JSX.Element | JSX.Element[];
  border?: 'bold';
  qaId?: string;
}

const Card: FC<IProps> = ({
  link,
  icon,
  title,
  description,
  goToAction,
  size,
  border,
  children,
  qaId,
}) => {
  return (
    <Link
      textDecoration="none"
      to={link}
      className={classNames(css.card, {
        [css[`card_size_${size}`]]: size,
        [css[`card_border_${border}`]]: border,
        [css.card_height_auto]: !goToAction,
      })}
      {...setQaAttribute(qaId)}
    >
      {children}
      {!children && (
        <>
          {icon && (
            <div className={css.card__icon} {...setQaAttribute(SUPPORT_CARD_ICON)}>
              {icon.url ? (
                <img className={css.card__img} src={icon.url} alt={icon.name} />
              ) : (
                <Icon id={icon.name as string} />
              )}
            </div>
          )}
          <div className={css.card__title} {...setQaAttribute(SUPPORT_CARD_NAME)}>
            {children || title}
          </div>
          {description && <div className={css.card__description}>{description}</div>}
          {goToAction && (
            <div className={css.card__action}>
              <span className={css.card__actionTitle}>{goToAction.title}</span>
              <div className={css.card__actionIcon}>
                <Icon id={goToAction.icon} />
              </div>
            </div>
          )}
        </>
      )}
    </Link>
  );
};

export default Card;
